import { vehicleManufacturersSlice } from "./vehicleManufacturersSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = vehicleManufacturersSlice;
export const moduleUrl = "/api/appmasterdata/vehicleManufacturers";

export const setValidationErrors = actions.setValidationErrors;

export const getVehicleManufacturers = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getVehicleManufacturer = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const saveVehicleManufacturer = (item: {}, id: string | null) => defaultActions.saveItem(moduleUrl, actions, item, id);
export const deleteVehicleManufacturer = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);

export const clearAll = () => defaultActions.clearAll(actions);
export const clearVehicleManufacturer = () => defaultActions.clearItem(actions);
export const clearErrors = () => defaultActions.clearErrors(actions);

export const getFilters = () => defaultActions.getFilters(moduleUrl, actions);
export const setFilter = (filters: any) => defaultActions.setFilters(filters, actions);
